import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'zone.js';

import { AppModule } from './app/app.module';

import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';
Sentry.init({
	dsn: 'https://377e5f5c89e250acfa8486859698e690@logs.smoothr.de/2',
	integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration({ maskAllInputs: true, stickySession: true, blockAllMedia: true, mutationLimit: 500, mutationBreadcrumbLimit: 100 })],
	tracesSampleRate: 0.1,
	profilesSampleRate: 0.1,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	environment: environment.production ? 'production' : 'development',
});

if (environment.production) {
	enableProdMode();
}
platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.error(err));
